import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { Col, Row } from 'react-bootstrap';
import { EmailsObjectType } from '../../types';
import EmailsCard from './components/EmailsCard';

interface EmailsSettingsTabI {
  setAddExtractEmailModalShow: Dispatch<SetStateAction<boolean>>;
  hasExtractEmailsToBeRendered: boolean;
  extractEmails: EmailsObjectType[];
  setExtractEmailToRemove: Dispatch<SetStateAction<string>>;
  setRemoveExtractEmailModalShow:  Dispatch<SetStateAction<boolean>>;
  extractEmailToRemove: string;
  removeExtractEmail: () => void;
  addExtractEmailModalShow: boolean;
  extractEmailToAdd: string;
  handleExtractEmailToAddChange: (event: ChangeEvent<HTMLInputElement>) => void;
  addExtractEmail: () => void;
  removeExtractEmailModalShow: boolean;
  resetExtractEmails: () => void;
  hasOriginalExtractEmailsChanged: boolean;
  setAddRoutingEmailModalShow: Dispatch<SetStateAction<boolean>>;
  hasRoutingEmailsToBeRendered: boolean;
  routingEmails: EmailsObjectType[];
  setRoutingEmails: Dispatch<SetStateAction<EmailsObjectType[]>>;
  setRoutingEmailToRemove: Dispatch<SetStateAction<string>>;
  setRemoveRoutingEmailModalShow:  Dispatch<SetStateAction<boolean>>;
  routingEmailToRemove: string;
  removeRoutingEmail: () => void;
  addRoutingEmailModalShow: boolean;
  routingEmailToAdd: string;
  handleRoutingEmailToAddChange: (event: ChangeEvent<HTMLInputElement>) => void;
  addRoutingEmail:  () => void;
  removeRoutingEmailModalShow: boolean;
  resetRoutingEmails: () => void;
  hasOriginalRoutingEmailsChanged: boolean;
  setAddRoutingNoResultEmailModalShow: Dispatch<SetStateAction<boolean>>;
  hasRoutingNoResultEmailsToBeRendered: boolean;
  routingNoResultEmails: EmailsObjectType[];
  setRoutingNoResultEmailToRemove: Dispatch<SetStateAction<string>>;
  setRemoveRoutingNoResultEmailModalShow: Dispatch<SetStateAction<boolean>>;
  routingNoResultEmailToRemove: string;
  removeRoutingNoResultEmail: () => void;
  addRoutingNoResultEmailModalShow: boolean;
  routingNoResultEmailToAdd: string;
  handleRoutingNoResultEmailToAddChange: (event: ChangeEvent<HTMLInputElement>) => void;
  addRoutingNoResultEmail: () => void;
  removeRoutingNoResultEmailModalShow:  boolean;
  resetRoutingNoResultEmails: () => void;
  hasOriginalRoutingNoResultEmailsChanged: boolean;
  extractEmailOwnerNameToAdd: string;
  handleExtractEmailOwnerNameToAddChange: (event: ChangeEvent<HTMLInputElement>) => void;
  routingEmailOwnerNameToAdd: string;
  handleRoutingEmailOwnerNameToAddChange: (event: ChangeEvent<HTMLInputElement>) => void;
  routingNoResultEmailOwnerNameToAdd: string;
  handleRoutingNoResultEmailOwnerNameToAddChange: (event: ChangeEvent<HTMLInputElement>) => void;
  vtItensRelationsRequestEmailOwnerNameToAdd: string;
  handleVtItensRelationsRequestEmailOwnerNameToAddChange: (event: ChangeEvent<HTMLInputElement>) => void;
  addVtItensRelationsRequestEmailModalShow: boolean;
  vtItensRelationsRequestEmailToAdd: string;
  handleVtItensRelationsRequestEmailToAddChange: (event: ChangeEvent<HTMLInputElement>) => void;
  addVtItensRelationsRequestEmail: () => void;
  removeVtItensRelationsRequestEmailModalShow: boolean;
  resetVtItensRelationsRequestEmails: () => void;
  hasOriginalVtItensRelationsRequestEmailsChanged: boolean;
  vtItensRelationsRequestEmails: EmailsObjectType[];
  vtItensRelationsRequestEmailToRemove: string;
  setVtItensRelationsRequestEmailToRemove: Dispatch<SetStateAction<string>>;
  setRemoveVtItensRelationsRequestEmailModalShow: Dispatch<SetStateAction<boolean>>;
  removeVtItensRelationsRequestEmail: () => void;
  setAddVtItensRelationsRequestEmailModalShow: Dispatch<SetStateAction<boolean>>;
  hasVtItensRelationsRequestEmailsToBeRendered: boolean;
  financialEmailOwnerNameToAdd: string;
  handleFinancialEmailOwnerNameToAddChange: (event: ChangeEvent<HTMLInputElement>) => void;
  addFinancialEmail: () => void;
  removeFinancialEmailModalShow: boolean;
  resetFinancialEmails: () => void;
  hasOriginalFinancialEmailsChanged: boolean;
  financialEmails: EmailsObjectType[];
  financialEmailToAdd: string;
  handleFinancialEmailToAddChange: (event: ChangeEvent<HTMLInputElement>) => void;
  financialEmailToRemove: string;
  setFinancialEmailToRemove: Dispatch<SetStateAction<string>>;
  setRemoveFinancialEmailModalShow: Dispatch<SetStateAction<boolean>>;
  removeFinancialEmail: () => void;
  addFinancialEmailModalShow: boolean;
  setAddFinancialEmailModalShow: Dispatch<SetStateAction<boolean>>;
  hasFinancialEmailsToBeRendered: boolean;
}

export default function EmailsSettingsTab({
  setAddExtractEmailModalShow,
  hasExtractEmailsToBeRendered,
  extractEmails,
  setExtractEmailToRemove,
  setRemoveExtractEmailModalShow,
  extractEmailToRemove,
  removeExtractEmail,
  addExtractEmailModalShow,
  extractEmailToAdd,
  handleExtractEmailToAddChange,
  addExtractEmail,
  removeExtractEmailModalShow,
  resetExtractEmails,
  hasOriginalExtractEmailsChanged,
  setAddRoutingEmailModalShow,
  hasRoutingEmailsToBeRendered,
  routingEmails,
  setRoutingEmailToRemove,
  setRemoveRoutingEmailModalShow,
  routingEmailToRemove,
  removeRoutingEmail,
  addRoutingEmailModalShow,
  routingEmailToAdd,
  handleRoutingEmailToAddChange,
  addRoutingEmail,
  removeRoutingEmailModalShow,
  resetRoutingEmails,
  hasOriginalRoutingEmailsChanged,
  setAddRoutingNoResultEmailModalShow,
  hasRoutingNoResultEmailsToBeRendered,
  routingNoResultEmails,
  setRoutingNoResultEmailToRemove,
  setRemoveRoutingNoResultEmailModalShow,
  routingNoResultEmailToRemove,
  removeRoutingNoResultEmail,
  addRoutingNoResultEmailModalShow,
  routingNoResultEmailToAdd,
  handleRoutingNoResultEmailToAddChange,
  addRoutingNoResultEmail,
  removeRoutingNoResultEmailModalShow,
  resetRoutingNoResultEmails,
  hasOriginalRoutingNoResultEmailsChanged,
  extractEmailOwnerNameToAdd,
  handleExtractEmailOwnerNameToAddChange,
  routingEmailOwnerNameToAdd,
  handleRoutingEmailOwnerNameToAddChange,
  routingNoResultEmailOwnerNameToAdd,
  handleRoutingNoResultEmailOwnerNameToAddChange,
  vtItensRelationsRequestEmailOwnerNameToAdd,
  handleVtItensRelationsRequestEmailOwnerNameToAddChange,
  addVtItensRelationsRequestEmail,
  removeVtItensRelationsRequestEmailModalShow,
  resetVtItensRelationsRequestEmails,
  hasOriginalVtItensRelationsRequestEmailsChanged,
  vtItensRelationsRequestEmails,
  vtItensRelationsRequestEmailToAdd,
  handleVtItensRelationsRequestEmailToAddChange,
  vtItensRelationsRequestEmailToRemove,
  setVtItensRelationsRequestEmailToRemove,
  setRemoveVtItensRelationsRequestEmailModalShow,
  removeVtItensRelationsRequestEmail,
  addVtItensRelationsRequestEmailModalShow,
  setAddVtItensRelationsRequestEmailModalShow,
  hasVtItensRelationsRequestEmailsToBeRendered,
  financialEmailOwnerNameToAdd,
  handleFinancialEmailOwnerNameToAddChange,
  addFinancialEmail,
  removeFinancialEmailModalShow,
  resetFinancialEmails,
  hasOriginalFinancialEmailsChanged,
  financialEmails,
  financialEmailToAdd,
  handleFinancialEmailToAddChange,
  financialEmailToRemove,
  setFinancialEmailToRemove,
  setRemoveFinancialEmailModalShow,
  removeFinancialEmail,
  addFinancialEmailModalShow,
  setAddFinancialEmailModalShow,
  hasFinancialEmailsToBeRendered,
}: EmailsSettingsTabI) {
  return (
    <Row xs={1} md={1} lg={1}>
      <Col>
        <EmailsCard
          setAddEmailModalShow={setAddExtractEmailModalShow}
          hasEmailsToBeRendered={hasExtractEmailsToBeRendered}
          emails={extractEmails}
          setEmailToRemove={setExtractEmailToRemove}
          setRemoveEmailModalShow={setRemoveExtractEmailModalShow}
          emailToRemove={extractEmailToRemove}
          removeEmail={() => removeExtractEmail()}
          addEmailModalShow={addExtractEmailModalShow}
          emailToAdd={extractEmailToAdd}
          handleEmailToAddChange={handleExtractEmailToAddChange}
          addEmail={() => addExtractEmail()}
          removeEmailModalShow={removeExtractEmailModalShow}
          resetEmails={() => resetExtractEmails()}
          hasOriginalEmailsChanged={hasOriginalExtractEmailsChanged}
          titleLabel="E-mails para recebimento de extrato de consultas realizadas"
          emailOwnerName={extractEmailOwnerNameToAdd}
          handleEmailOwnerNameChange={handleExtractEmailOwnerNameToAddChange}
        />
      </Col>
      <Col>
        <EmailsCard
          setAddEmailModalShow={setAddRoutingEmailModalShow}
          hasEmailsToBeRendered={hasRoutingEmailsToBeRendered}
          emails={routingEmails}
          setEmailToRemove={setRoutingEmailToRemove}
          setRemoveEmailModalShow={setRemoveRoutingEmailModalShow}
          emailToRemove={routingEmailToRemove}
          removeEmail={() => removeRoutingEmail()}
          addEmailModalShow={addRoutingEmailModalShow}
          emailToAdd={routingEmailToAdd}
          handleEmailToAddChange={handleRoutingEmailToAddChange}
          addEmail={() => addRoutingEmail()}
          removeEmailModalShow={removeRoutingEmailModalShow}
          resetEmails={() => resetRoutingEmails()}
          hasOriginalEmailsChanged={hasOriginalRoutingEmailsChanged}
          titleLabel="E-mails para recebimento de roteirização implantada"
          emailOwnerName={routingEmailOwnerNameToAdd}
          handleEmailOwnerNameChange={handleRoutingEmailOwnerNameToAddChange}
        />
      </Col>
      <Col>
        <EmailsCard
          setAddEmailModalShow={setAddRoutingNoResultEmailModalShow}
          hasEmailsToBeRendered={hasRoutingNoResultEmailsToBeRendered}
          emails={routingNoResultEmails}
          setEmailToRemove={setRoutingNoResultEmailToRemove}
          setRemoveEmailModalShow={setRemoveRoutingNoResultEmailModalShow}
          emailToRemove={routingNoResultEmailToRemove}
          removeEmail={() => removeRoutingNoResultEmail()}
          addEmailModalShow={addRoutingNoResultEmailModalShow}
          emailToAdd={routingNoResultEmailToAdd}
          handleEmailToAddChange={handleRoutingNoResultEmailToAddChange}
          addEmail={() => addRoutingNoResultEmail()}
          removeEmailModalShow={removeRoutingNoResultEmailModalShow}
          resetEmails={() => resetRoutingNoResultEmails()}
          hasOriginalEmailsChanged={hasOriginalRoutingNoResultEmailsChanged}
          titleLabel="E-mails para recebimento de roteirizações sem resultado"
          emailOwnerName={routingNoResultEmailOwnerNameToAdd}
          handleEmailOwnerNameChange={handleRoutingNoResultEmailOwnerNameToAddChange}
        />
      </Col>
      <Col>
        <EmailsCard
          setAddEmailModalShow={setAddVtItensRelationsRequestEmailModalShow}
          hasEmailsToBeRendered={hasVtItensRelationsRequestEmailsToBeRendered}
          emails={vtItensRelationsRequestEmails}
          setEmailToRemove={setVtItensRelationsRequestEmailToRemove}
          setRemoveEmailModalShow={setRemoveVtItensRelationsRequestEmailModalShow}
          emailToRemove={vtItensRelationsRequestEmailToRemove}
          removeEmail={() => removeVtItensRelationsRequestEmail()}
          addEmailModalShow={addVtItensRelationsRequestEmailModalShow}
          emailToAdd={vtItensRelationsRequestEmailToAdd}
          handleEmailToAddChange={handleVtItensRelationsRequestEmailToAddChange}
          addEmail={() => addVtItensRelationsRequestEmail()}
          removeEmailModalShow={removeVtItensRelationsRequestEmailModalShow}
          resetEmails={() => resetVtItensRelationsRequestEmails()}
          hasOriginalEmailsChanged={hasOriginalVtItensRelationsRequestEmailsChanged}
          titleLabel="E-mails para recebimento de solicitação de relacionamento de item para consultas estacionadas"
          emailOwnerName={vtItensRelationsRequestEmailOwnerNameToAdd}
          handleEmailOwnerNameChange={handleVtItensRelationsRequestEmailOwnerNameToAddChange}
        />
      </Col>
      <Col>
        <EmailsCard
          setAddEmailModalShow={setAddFinancialEmailModalShow}
          hasEmailsToBeRendered={hasFinancialEmailsToBeRendered}
          emails={financialEmails}
          setEmailToRemove={setFinancialEmailToRemove}
          setRemoveEmailModalShow={setRemoveFinancialEmailModalShow}
          emailToRemove={financialEmailToRemove}
          removeEmail={() => removeFinancialEmail()}
          addEmailModalShow={addFinancialEmailModalShow}
          emailToAdd={financialEmailToAdd}
          handleEmailToAddChange={handleFinancialEmailToAddChange}
          addEmail={() => addFinancialEmail()}
          removeEmailModalShow={removeFinancialEmailModalShow}
          resetEmails={() => resetFinancialEmails()}
          hasOriginalEmailsChanged={hasOriginalFinancialEmailsChanged}
          titleLabel="E-mails para recebimento de notificações do financeiro"
          emailOwnerName={financialEmailOwnerNameToAdd}
          handleEmailOwnerNameChange={handleFinancialEmailOwnerNameToAddChange}
        />
      </Col>
    </Row>
  );
}
